export default __webpack_public_path__ + "static/media/icon-meter.5eb01919.svg";